export default __webpack_public_path__ + "static/media/nextuLogo.e033dbfa.webp";